import Fetch from '../Fetch';

export default {
  queryDeviceInfo: (params,success, error) => {//获取交换机信息
    return Fetch.get(`/api/v1/device_info`,{params});
  },
  queryDeviceTime: (params,success, error) => {//获取设备当前时间
    return Fetch.get(`/api/v1/device_time`,{params});
  },
  rebootOrShutdownDevice: (params, success, error) => {//重启交换机
    return Fetch.post(`/api/v1/device_power`, params);
  },
  updateSystemName: (params, success, error) => {//设置交换机系统名称
    return Fetch.post(`/api/v1/device_name`, params);
  },
  updateDeviceDateTime: (params, success, error) => {//设置设备当前时间
    return Fetch.post(`/api/v1/device_time`, params);
  },
  updateSntpService: (params, success, error) => {//设置SNTP服务器
    return Fetch.post(`/api/v1/sntp_server_cfg`, params);
  },
  queryLinkAggregation: (params, success, error) => {//获取LAG
    return Fetch.get(`/api/v1/sw_lag_cfg`, {params});
  },
  updateLinkAggregation: (params, success, error) => {//设置LAG
    return Fetch.post(`/api/v1/sw_lag_cfg`, params);
  },
  deleteLinkAggregation: (params, success, error) => {//删除LAG
    return Fetch.delete(`/api/v1/sw_lag_cfg`, {params});
  },
  querySntpService: (success, error) => {//查询SNTP服务器
    return Fetch.get(`/api/v1/sntp_server_cfg`);
  },
  queryCableTest: (params, success, error) => {//获取 cable test状态
    return Fetch.post(`/api/v1/cable_test`,params);
  },
  updateFanMode: (params, success, error) => {//Fan button(更新fan mode)
    return Fetch.post(`/api/v1/device_fan`,params);
  },
  updateBridgePriority: (params, success, error) => {//更新Bridge Priority
    return Fetch.post(`/api/v1/spanning_tree`,params);
  },
  querySpecialRouteInfo: (params, success, error) => {//获取 oob路由实现信息
    return Fetch.get(`/api/v1/special_interface_route`,{params});
  },
  updateSpecialRoute: (params, success, error) => {//更新oob路由实现信息
    return Fetch.post(`/api/v1/special_interface_route`,params);
  },
  queryVlanRouteInfo: (params, success, error) => {//获取management路由实现信息
    return Fetch.get(`/api/v1/vlan_interface_route`,{params});
  },
  updateVlanRoute: (params, success, error) => {//更新management路由实现信息
    return Fetch.post(`/api/v1/vlan_interface_route`,params);
  },
  querySpecialRouteInfoPromise: (params) => {//获取 oob路由实现信息
    return Fetch.get(`/api/v1/special_interface_route`, {params});
  },
}
